module.exports = __webpack_public_path__ + "static/media/work-img4-5.e4627734.png";